import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import HubPage from "../pages/hub/page";
import Tracking from "../pages/tracking/page";
import DynamicDepartmentPage from "../pages/department/page";
import MisTicketsPage from "../pages/mis-tickets/page";
import EstadisticasPage from "../pages/estadisticas/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <HubPage />,
  },
  {
    path: "/ti/tracking",
    element: <Tracking />,
  },
  {
    path: "/mis-tickets",
    element: <MisTicketsPage />,
  },
  {
    path: "/estadisticas",
    element: <EstadisticasPage />,
  },
  {
    path: "/:deptId",
    element: <DynamicDepartmentPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;